import React from 'react';
import styles from '../DailyTrainingPage.module.css';

/**
 * CompletedState component for DailyTrainingPage
 * 
 * Displays a completion message when all items in the session have been reviewed.
 */
interface CompletedStateProps {
  count: number;
}

const CompletedState: React.FC<CompletedStateProps> = ({ count }) => (
  <div className={styles.completedState}>
    <h2>Session complete!</h2>
    <p>Well done. You reviewed {count} items today.</p>
  </div>
);

export default React.memo(CompletedState); 